



















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MonitoringRestrainDetail extends Vue {
  @Prop() monitoring!: any;

  paramGroups = [
    {
      items: [
        { key: "kemerahan_tangan", label: "Kemerahan Tangan" },
        { key: "kemerahan_kaki", label: "Kemerahan Kaki" },
        { key: "biru_tangan", label: "Biru Tangan" },
        { key: "biru_kaki", label: "Biru Kaki" }
      ]
    },
    {
      items: [
        { key: "luka_tangan", label: "Luka Tangan" },
        { key: "luka_kaki", label: "Luka Kaki" }
      ]
    },
    {
      items: [
        { key: "nadi_melemah_tangan", label: "Nadi Melemah Tangan" },
        { key: "nadi_melemah_kaki", label: "Nadi Melemah Kaki" },
        { key: "nadi_tidak_teraba_tangan", label: "Nadi Tidak Teraba Tangan" },
        { key: "nadi_tidak_teraba_kaki", label: "Nadi Tidak Teraba Kaki" }
      ]
    }
  ];

  get jams() {
    return this.monitoring?.data_monitoring?.jam || [];
  }

  getCellVal(key: string, ji: number, side: string) {
    const data = this.monitoring?.data_monitoring;
    if (!data || !data[key] || !data[key][ji]) return "";
    return data[key][ji][side];
  }
}
